
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class CredenzialiDialog extends Serenity.EntityDialog<CredenzialiRow, any> {
        protected getFormKey() { return CredenzialiForm.formKey; }
        protected getIdProperty() { return CredenzialiRow.idProperty; }
        protected getLocalTextPrefix() { return CredenzialiRow.localTextPrefix; }
        protected getNameProperty() { return CredenzialiRow.nameProperty; }
        protected getService() { return CredenzialiService.baseUrl; }
        protected getDeletePermission() { return CredenzialiRow.deletePermission; }
        protected getInsertPermission() { return CredenzialiRow.insertPermission; }
        protected getUpdatePermission() { return CredenzialiRow.updatePermission; }

        protected form = new CredenzialiForm(this.idPrefix);

    }
}